<div class="fullscreen" [ngClass]="{ 'dark-theme': theme() === 'dark' }">

<div class="toolbar">
  <button class="icon-btn" (click)="downloadImage()">
    <img src="../../../assets/logo/download-solid.svg" alt="" height="15px" width="15px">
  </button>

  <button class="icon-btn" (click)="rotateLeft()">
    <img src="../../../assets/logo/rotate-left-solid.svg" alt="" height="15px" width="15px">
  </button>

   <button class="icon-btn" (click)="rotateRight()">
    <img src="../../../assets/logo/rotate-right-solid.svg" alt="" height="15px" width="15px">
  </button>

  <button class="icon-btn" (click)="zoomIn()">
     <img src="../../../assets/logo/magnifying-glass-plus-regular.svg" alt="" height="15px" width="15px">
  </button>

  <button class="icon-btn" (click)="zoomOut()">
    <img src="../../../assets/logo/magnifying-glass-minus-regular.svg" alt="" height="15px" width="15px">
  </button>

  <button class="icon-btn" (click)="toggleFullscreen()">
  <img
    src="../../../assets/logo/xmark-solid.svg"
    alt="Toggle Fullscreen"
    height="15px"
    width="15px"
  />
</button>

</div>




<div class="image-container text-center">
  <!-- Check if current file is an image -->
  <ng-container *ngIf="isImage(images[currentIndex]); else nonImageTemplate">
    <img
      class="main-image"
      [src]="images[currentIndex]"
      [alt]="'Image ' + (currentIndex + 1)"
      [style.transform]="'scale(' + zoomLevel() + ') rotate(' + rotation() + 'deg)'"
    />
  </ng-container>

  <!-- If not an image, show generic file and file name -->
  <ng-template #nonImageTemplate>
    <div class="non-image-content">
      <img
        class="main-image w-40 h-40 object-contain mx-auto"
        src="../../../assets/images/genericFile.png"
        alt="File"
      />
      <p class="file-name">
        {{ getFileName(images[currentIndex]) }}
      </p>
    </div>
  </ng-template>

</div>

<!-- Thumbnails Wrapper -->
<div class="thumbnails-wrapper" *ngIf="showThumbnails">
  <div #thumbnailContainer class="thumbnails">
    <!-- Left Scroll Button -->
    <button class="thumb-nav left" (click)="prev()">
      <img src="../../../assets/logo/arrow-left-solid.svg" alt="Left" class="arrow-icon" height="20px" width="20px" />
    </button>

    <!-- Thumbnail Images -->
    <img
      *ngFor="let img of images; let i = index"
      [src]="isImage(img) ? img : '../../../assets/images/genericFile.png'"
      [alt]="getFileName(img)"
      [class.active]="i === currentIndex"
      (click)="select(i)"
    />

    <!-- Right Scroll Button -->
    <button class="thumb-nav right" (click)="next()">
      <img src="../../../assets/logo/arrow-right-solid.svg" alt="Right" class="arrow-icon" height="20px" width="20px" />
    </button>
  </div>
</div>


</div>
